<template>
    <div>
        <!-- Modal Observações -->
        <div class="modal fade" id="obsModelModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ocorrências</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!nova && ( !lista || !lista.length )" msg="Nenhuma ocorrência registrada."/>

                        <template v-else>

                            <ul class="list-group mb-3">
                                <li class="list-group-item" :class="item.tipo.st_cor ? 'list-group-item-' + item.tipo.st_cor : ''" v-for="(item, iix) in lista" :key="iix">
                                    <div>
                                        <span class="badge" :class="item.tipo.st_cor ? 'badge-' + item.tipo.st_cor : 'badge-secondary'">
                                            {{ item.tipo.st_tipo_observacao }}
                                        </span>
                                    </div>

                                    <div>
                                        <span class="small text-muted">
                                            {{ $util.getFormatDate(item.created_at) }}
                                            {{ item.created_at.substr(11,5) }}
                                            <span v-if="item.usuario">
                                                <i class="fa fa-caret-right mx-3" aria-hidden="true"></i>
                                                {{ item.usuario.st_login }}
                                            </span>
                                        </span>
                                    </div>

                                    <div style="white-space: pre-wrap;">{{ item.st_observacao }}</div>
                                </li>
                            </ul>

                            <div v-if="nova">
                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            label="Tipo"
                                            placeholder="Selecione..."
                                            type="select"
                                            optionsData="id_observacao_tipo"
                                            service="observacao_tipos.index"
                                            optionsMode="aql"
                                            v-model="nova.id_observacao_tipo" />
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col col-12">
                                        <az-input
                                            label="Observação"
                                            placeholder="Informa a observação..."
                                            type="textarea"
                                            rows="3"
                                            v-model="nova.st_observacao" />
                                    </div>
                                </div>

                                <div class="mt-2">
                                    <az-submit color="success btn-sm" @click="atualizar()">
                                        <i class="fa fa-check fa-fw" aria-hidden="true"></i>
                                    </az-submit>                    
                                    <button type="button" class="btn btn-sm ml-1 btn-outline-danger" @click="nova = null">
                                        <i class="fa fa-times fa-fw" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>

                        </template>

                        <button type="button" class="btn btn-primary btn-sm" @click="incluir()" v-if="!nova">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../util/AzEmptyState.vue';
import AzInput from '../shared/forms/AzInput.vue';
import AzSubmit from '../util/AzSubmit.vue';

export default {
    data() { 
        return { 
            model: null,
            id: null, 
            lista: null, 
            nova: null, 
            validate: false, 
        };
    },

    components: { 
        AzEmptyState, 
        AzInput, 
        AzSubmit
    },

    methods: { 
        incluir() { 
            this.nova = { 
                id_observacao_tipo: "", 
                model_type: 'App\\azure\\' + this.model,
                model_id: this.id,
                st_tipo_observacao: "",
                fl_ativo: true, 
            };
        },

        atualizar () { 
            this.$util.atualizar(this, { 
                service: 'observacoes',
                func: 'store',
                dados: this.nova,
                modal: 'obsModelModal',
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        abrir(model, id) { 
            this.nova = null;
            this.model = model;
            this.id = id;
            this.lista = null; 
            this.validate = false;

            $('#obsModelModal').modal('show');

            this.$util.load(this, { 
                service: 'observacoes',
                func: 'index', 
                parms: { 
                    model: this.model,
                    id: this.id,
                },
                loadTo: res => { 
                    this.lista = res;
                }
            });
        },

        fechar() { 
            $('#obsModelModal').modal('hide');
        }
    }
}
</script>
